module.exports = __webpack_public_path__ + "32727ea096c7c5bb1bbcb85925110807.MP3";